import React from 'react';

const Save = ({ className }) => {
    return (
        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21.5" cy="21.5" r="21.5" fill="#232323" fillOpacity="0.96" />
            <path d="M14 27V16C14 14.8954 14.8954 14 16 14H24.7C25.2136 14 25.7074 14.1976 26.0793 14.5517L28.3793 16.7422C28.7757 17.1197 29 17.6431 29 18.1905V27C29 28.1046 28.1046 29 27 29H16C14.8954 29 14 28.1046 14 27Z" fill="white" />
            <rect x="16.1428" y="15.0713" width="8.57143" height="3.21429" fill="#232323" />
            <circle cx="22.0357" cy="25.2499" r="2.67857" fill="#232323" />
        </svg>
    )
}

export default Save;